import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Dashboard route
 *
 * @extends KernelRoute
 */
class SubscriptionRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/subscription(/)")
    route () {
        System.import("./index").then(View => {
            const view = new View.default();

            raf(_ => App.contentRegion.show(view));
        });
    }

}

export default SubscriptionRoute;



// WEBPACK FOOTER //
// ./public/domain/views/subscription/subscription.route.js